<template>
  <div class="botaccount" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''">
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary'>
      <v-icon x-medium class="white--text">
        mdi-checkbox-marked-circle
      </v-icon>
      <span>{{ alertMessage }}</span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red'>
      <v-icon x-medium class="white--text">
        mdi-minus-circle
      </v-icon>
      <span>{{ alertMessage }}</span>
    </v-snackbar>

    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>

    <template>
      <v-toolbar flat>
        <v-toolbar-title style="margin-left: 20px; display: flex; align-items: flex-start;">
          <v-icon class="mr-2" style="align-self: flex-start; margin-top: 2px;">
            mdi-facebook
          </v-icon>
          {{ this.$store.state.title }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-flex lg3>
          <v-text-field
            class="pt-3 mr-4"
            append-icon="mdi-magnify"
            label="Search"
            v-model="search"
          ></v-text-field>
        </v-flex>

        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-show="insertAction"
              outlined
              rounded
              small
              dark
              v-bind="attrs"
              v-on="on"
              class="mb-2"
              color="primary"
            >
              Add New Bot Account
              <v-icon class="ml-2">
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h6">
                {{ formTitle }}
              </span>
            </v-card-title>
            <v-card-text class="overflow-card" style="height: 450px;">
              <v-form class="ml-2" ref="form" lazy-validation>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        label="Username"
                        hint="Input Username"
                        v-model="itemInput.username"
                        :rules="usernameRules"
                        outlined
                        dense
                        persistent-hint
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <div v-if="!fileCookie">
                        <div
                          :class="[
                            'drop-zone-file-cookie',
                            draggingFileCookie ? 'drop-zone-file-cookie-over' : '',
                          ]"
                          @dragenter="draggingFileCookie = true"
                          @dragleave="draggingFileCookie = false"
                        >
                          <div
                            class="drop-zone-file-cookie-info"
                            ref="file"
                            @drag="selectFileCookie"
                          >
                            <span class="fa fa-cloud-upload drop-zone-file-cookie-title"></span>
                            <span class="drop-zone-file-cookie-title">
                              Drop file cookie or click to input<br />
                            </span>
                            <div class="drop-zone-file-cookie-upload-limit-info"></div>
                          </div>
                          <input
                            type="file"
                            ref="file"
                            id="files"
                            name="files"
                            @change="selectFileCookie"
                          />
                        </div>
                      </div>

                      <div v-else class="drop-zone-file-cookie-uploaded">
                        <div class="drop-zone-file-cookie-uploaded-info">
                          <button
                            class="btn remove-file-cookie"
                            style="background-color: #439EDF; color: #fff; border: none;"
                            type="button"
                            @click="removeFileCookie"
                          >
                            Remove File Cookie
                          </button>
                          <span class="drop-zone-file-cookie-title"></span><br />
                          <v-col>{{ nameFileCookie }}</v-col>
                        </div>
                      </div>
                    </v-col>

                    <p v-if="fileCookieError" class="ml-3 red--text">
                      File cookie is required
                    </p>

                    <v-col cols="12" sm="12" md="12">
                      <v-btn
                        class="mb-2"
                        color="success"
                        medium
                        :loading="loadingTestFileCookie"
                        @click="testFileCookie"
                      >
                        Test
                      </v-btn>
                      <div class="ml-1">
                        <span class="font-weight-medium">Status:</span>
                        <span
                          :class="statusCookie == 'Success' ? 'green--text' : 'red--text'"
                          class="ml-1"
                        >
                          {{ statusCookie }}
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions class="py-3">
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                style="width: 90px;"
                rounded
                outlined
                dense
                @click="close"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                style="width: 90px;"
                rounded
                dense
                :dark="statusCookie == 'Success'"
                :loading="btnLoading"
                :disabled="statusCookie != 'Success'"
                @click="save"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogWrongExtension" persistent max-width="330px">
          <v-card
            class="text-center align-center justify-center pa-6 rounded-lg"
            style="border-radius: 30px"
            width="330px"
          >
            <v-avatar class="dialog-wrong-extension mb-4 mt-2" size="62">
              <v-icon x-large class="white--text">
                mdi-close
              </v-icon>
            </v-avatar>
            <div class="text-center text-h6 align-center justify-center" style="word-break: break-word">
              File cookie you uploaded has the wrong extension.
            </div>
            <v-divider class="mt-4"></v-divider>
            <v-card-actions class="align-center justify-center">
              <v-btn
                class="my-3 dialog-wrong-extension"
                width="180px"
                rounded
                dark
                @click="dialogWrongExtension = false, removeFileCookie()"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDelete" width="330px">
          <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
            <v-avatar class="color-avatar-warning my-4" size="62">
              <v-icon x-large class="white--text">
                mdi-alert-octagon
              </v-icon>
            </v-avatar>
            <div class="text-center text-h6 align-center justify-center font-weight-medium">
              Confirm Deletion
            </div>
            <v-card-text class="align-center justify-center mt-2">
              Are you sure you want to permanently delete this item?
            </v-card-text>
            <v-divider class="mt-4"></v-divider>
            <v-card-actions class="align-center justify-center">
              <v-btn class="my-3 btn-ok" width="90px" rounded dark @click="deleteItemConfirm">
                OK
              </v-btn>
              <v-btn class="my-3" width="90px" color="red" rounded outlined dark @click="closeDelete">
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogInformasiBot" max-width="700px">
          <v-card>
            <v-card-title>
              <span class="text-h6">
                Bot Account Facebook
              </span>
            </v-card-title>
            <v-card-text>
              <v-list-item>
                <v-list-item-avatar color="#EDF4FB">
                  <v-icon color="#439EDF" dark>
                    mdi-alert-outline
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ textDialogInvalid }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item>
                <v-list-item-avatar color="#EDF4FB">
                  <v-icon color="#439EDF" dark>
                    mdi-clock-outline
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Last Check</v-list-item-title>
                  <v-list-item-subtitle>{{ lastDateDialogInvalid }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item>
                <v-list-item-avatar color="#EDF4FB">
                  <v-icon color="#439EDF" dark>
                    mdi-message-text-outline
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Message</v-list-item-title>
                  <v-list-item-subtitle>{{ messageInvalidBot }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
            </v-card-text>
            <v-card-actions class="py-3">
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                style="width: 90px;"
                rounded
                outlined
                dense
                @click="dialogInformasiBot = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <v-data-table
      :headers="headers"
      :items="botAccount"
      :search="search"
      :single-expand="true"
      :expanded.sync="expanded"
      item-key="SEQ_ID"
      class="table-user ml-6 mr-6 mt-4 rounded-lg"
      :loading="tableLoading"
      loading-text="Loading data..."
      show-expand
    >
      <template v-slot:item.valid="{ item }">
        <v-icon
          class="mr-2"
          small
          @click="informasiItemBot(item.last_checked, item.created_at, item.MESSAGE)"
          :style="{
            color: item.valid == 1 ? 'blue' : 'red',
            borderRadius: '50%',
            visibility: item.valid == 1 ? 'hidden' : 'visible',
          }"
        >
          {{ item.valid == 1 ? 'mdi-star' : 'mdi-alert-outline' }}
        </v-icon>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon v-show="updateAction" small class="mr-2" @click="editItem(item.SEQ_ID)">
          mdi-pencil
        </v-icon>
        <v-icon v-show="deleteAction" small @click="deleteItem(item.SEQ_ID)">
          mdi-delete
        </v-icon>
      </template>

      <template v-slot:no-data>
        <p class="mt-4">
          No Facebook bot accounts found.
        </p>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <v-expand-transition>
          <td :colspan="headers.length" class="pa-3">
            <p>Created At: {{ item.created_at }}</p>
            <p>Last Checked: {{ item.last_checked }}</p>
            <p>Message: {{ item.MESSAGE }}</p>
          </td>
        </v-expand-transition>
      </template>
    </v-data-table>

    <Notification ref="alert"></Notification>
  </div>
</template>

<script>
import axios from "axios";
import { decryptionData } from '@/components/utils/utils.js';
import Notification from '@/components/Notification';
import { mapGetters } from 'vuex';
export default {
  components: {
    Notification: Notification
  },
  data: () => ({
    alertSuccess: '',
    alertFailed: '',
    alertMessage: '',
    search: '',
    insertAction: false,
    dialog: false,
    usernameRules: [
      v => !!v || 'username is required',
    ],
    fileCookie: "",
    draggingFileCookie: false,
    nameFileCookie: "",
    fileCookieError: false,
    loadingTestFileCookie: false,
    statusCookie: "",
    cookieValidationResult: null,
    btnLoading: false,
    dialogWrongExtension: false,
    dialogDelete: false,
    dialogInformasiBot: false,
    textDialogInvalid: '',
    lastDateDialogInvalid: '',
    messageInvalidBot: '',
    headers: [
      { text: '', value: 'data-table-expand', width: 60 },
      { text: '', value: 'valid', width: 20 },
      { text: 'USERNAME', value: 'USERNAME' },
      { text: 'Actions',  value: 'actions' },
    ],
    botAccount: [],
    expanded: [],
    singleExpand: true,
    tableLoading: false,
    updateAction: false,
    deleteAction: false,
    viewAction: false,
    idBotAccount: "",
    itemInput: {},
    defaultItem: {},
    editedIndex: -1,
  }),
  computed: {
    page() {
      return this.$store.state.breadcrumbs
    },
    ...mapGetters(['navbarWithName']),
    formTitle() {
      return this.editedIndex == -1 ? 'Add Bot Account' : 'Update Bot Account'
    },
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    selectFileCookie(event) {
      const file =
        event?.target?.files?.[0] ||
        event?.dataTransfer?.files?.[0];

      if (!file) return;

      const allowedExtensions = ["json", "txt"];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        this.dialogWrongExtension = true;
        this.draggingFileCookie = false;

        if (event?.target) {
          event.target.value = "";
        }

        return;
      }

      this.fileCookie = file;
      this.nameFileCookie = file.name;
      this.fileCookieError = false;
      this.draggingFileCookie = false;
    },
    removeFileCookie() {
      this.fileCookie = "";
      this.nameFileCookie = "";
      this.fileCookieError = false;
      this.statusCookie = null;

      if (this.$refs.file) {
        this.$refs.file.value = null;
      }
    },
    async testFileCookie() {
      this.statusCookie = "";
      this.loadingTestFileCookie = true;
      this.cookieValidationResult = null;

      if (!this.fileCookie) {
        this.fileCookieError = true;
        this.statusCookie = "Failed";

        setTimeout(() => {
          this.fileCookieError = false;
        }, 5000);

        this.loadingTestFileCookie = false;
        return;
      }

      try {
        const axiosInstance = axios.create({
          baseURL: "/apitestcookiefb",
        });

        const formData = new FormData();
        formData.append("username", this.itemInput.username);
        formData.append("file", this.fileCookie);

        await axiosInstance.post("/decode", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        const validCekResponse = await axiosInstance.get(
          `/valid-cek?username=${this.itemInput.username}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const result = validCekResponse.data;

        if (result?.status == "success" && result?.validation_details?.valid == 1) {
          this.statusCookie = "Success";

          this.cookieValidationResult = {
            massage: "Cookie valid [OK]",
            last_checked : this.formatDateTime(new Date()),
          };
        } else {
          this.statusCookie = "Failed";
        }
      } catch (error) {
        this.statusCookie = "Failed";
      } finally {
        this.loadingTestFileCookie = false;
      }
    },
    formatDateTime(date) {
      const d = new Date(date);
      const yyyy = d.getFullYear();
      const MM = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const HH = String(d.getHours()).padStart(2, '0');
      const mm = String(d.getMinutes()).padStart(2, '0');
      const ss = String(d.getSeconds()).padStart(2, '0');
      return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
    },
    save() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.btnLoading = true;

        if (this.editedIndex == -1) {
          this.botAccount.push(this.itemInput);
          axios.post("/bot_facebook/insert",
            {
              username: this.itemInput.username,
              massage: this.cookieValidationResult?.massage,
              last_checked: this.cookieValidationResult?.last_checked,
            },
            { headers: { 'auth-token': localStorage.getItem('token_app') } },
            { dataType: 'json' }
          )
          .then((response) => {
            var status = response.data.status;
            var message = response.data.msg;
            if (status == 200) {
              this.initialize();
              this.alertSuccess = true;
              this.alertMessage = message;
              this.btnLoading = false;
              this.close();
              this.removeFileCookie();
            } else {
              this.alertFailed = true;
              this.alertMessage = message;
              this.btnLoading = false;
              this.close();
              this.removeFileCookie();
            }
          })
          .catch((e) => {
            switch (e.response.status) {
              case 404: this.$refs.alert.error_login(404); break;
              case 403: this.$refs.alert.error_login(403); break;
              default : console.log(e.response.msg);       break;
            }
            this.btnLoading = false;
          });
        } else {
          Object.assign(this.botAccount[this.editedIndex], this.itemInput);
          axios.put("/bot_facebook/update",
            {
              seq_id: this.idBotAccount,
              username: this.itemInput.username,
              massage: this.cookieValidationResult?.massage,
              last_checked: this.cookieValidationResult?.last_checked,
            },
            { headers: { 'auth-token': localStorage.getItem('token_app') } },
            { dataType: 'json' }
          )
          .then((response) => {
            var status = response.data.status;
            var message = response.data.msg;
            if (status == 200) {
              this.initialize();
              this.alertSuccess = true;
              this.alertMessage = message;
              this.btnLoading = false;
              this.close();
              this.removeFileCookie();
            } else {
              this.alertFailed = true;
              this.alertMessage = message;
              this.btnLoading = false;
              this.close();
              this.removeFileCookie();
            }
          })
          .catch((e) => {
            switch (e.response.status) {
              case 404: this.$refs.alert.error_login(404); break;
              case 403: this.$refs.alert.error_login(403); break;
              default : console.log('some other error');   break;
            }
            this.btnLoading = false;
          });
        }
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.itemInput = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    informasiItemBot(last_date, last_update, message) {
      this.dialogInformasiBot = true;
      var date = last_date == "" ? last_update : last_date;

      this.textDialogInvalid = 'Bot Invalid';
      this.lastDateDialogInvalid = date;
      this.messageInvalidBot = message;
    },
    initialize() {
      this.tableLoading = true;
      axios.get("bot_facebook",
        { headers: { 'auth-token': localStorage.getItem('token_app') } },
        { dataType: 'json' }
      ).then((response) => {
        const data = decryptionData(response.data.token);
        this.botAccount = data;
        setTimeout(() => {
          this.loading = false;
        }, 1000);
        this.tableLoading = false;
        if (localStorage.getItem('authactdeletedt') == 1) { this.deleteAction = true; }
        if (localStorage.getItem('authactinsert') == 1)  { this.insertAction = true; }
        if (localStorage.getItem('authactupdate') == 1)  { this.updateAction = true; }
        if (localStorage.getItem('authactview') == 1)    { this.viewAction = true; }
      })
      .catch((e) => {
        switch (e.response.status) {
          case 404:
            this.$refs.alert.error_login(404);
            break;
          case 403:
            this.$refs.alert.error_login(403);
            break;
          default:
            console.log('some other error');
            break;
        }
        this.errors = e.data.msg;
      });
    },
    deleteItem(item) {
      this.idBotAccount = item;
      this.editedIndex = this.botAccount.indexOf(item);
      this.itemInput = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.botAccount.splice(this.editedIndex, 1);
      axios({
        method: "delete",
        url: "bot_facebook/delete",
        data: {
          id: this.idBotAccount
        },
        headers: { 'auth-token': localStorage.getItem('token_app') },
        dataType: 'json'
      })
      .then((response) => {
        var status = response.data.status;
        var message = response.data.msg;
        if (status == 200) {
          this.initialize();
          this.alertSuccess = true;
          this.alertMessage = message;
          this.closeDelete();
        } else {
          this.alertFailed = true;
          this.alertMessage = message;
        }
      })
      .catch(function (error) {
        this.alertFailed = true;
        this.alertMessage = 'Delete Failed ' + error;
      });
      this.closeDelete();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.itemInput = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    editItem(item) {
      this.statusCookie = "";
      this.removeFileCookie();

      this.editedIndex = 1;
      this.itemInput = Object.assign({}, item);
      this.dialog = true;
      axios({
        method: "put",
        url: "/bot_facebook_Id",
        data: {
          id: item
        },
        headers: { 'auth-token': localStorage.getItem('token_app') },
        dataType: 'json'
      })
      .then((response) => {
        const dat = decryptionData(response.data.token);
        this.idBotAccount = dat.SEQ_ID;
        this.itemInput = {
          name: dat.NAME,
          username: dat.USERNAME,
          password: dat.PASSWORD,
        };
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      })
      .catch(function (error) {
        console.log(error);
      });
    },
  },
}
</script>

<style scoped>
.drop-zone-file-cookie {
  position: relative;
  border: 2px dashed #eee;
  height: 200px;
  width: 100%;
}
.drop-zone-file-cookie:hover {
  border: 2px solid #439EDF;
}
.drop-zone-file-cookie:hover .drop-zone-file-cookie-title {
  color: #439EDF;
}
.drop-zone-file-cookie-over {
  background: #5c5c5c;
  opacity: 0.8;
}
.drop-zone-file-cookie input {
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
}
.drop-zone-file-cookie-info {
  color: #a8a8a8;
  position: absolute;
  text-align: center;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
}
.drop-zone-file-cookie-title {
  color: #787878;
}
.drop-zone-file-cookie-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.drop-zone-file-cookie-uploaded {
  position: relative;
  border: 2px dashed #eee;
  height: 200px;
  width: 100%;
}
.drop-zone-file-cookie-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a8a8a8;
  position: absolute;
  text-align: center;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
}
.remove-file-cookie {
  width: 200px;
}
.dialog-wrong-extension {
  background-image: linear-gradient(
    to bottom,
    #ff8b8b,
    #ff8284,
    #ff787d,
    #ff6e76,
    #ff646f,
    #ff5c6a,
    #ff5464,
    #ff4b5f,
    #ff4359,
    #ff3b54,
    #ff314e,
    #ff2648
  );
}
.btn-ok {
  background-image: linear-gradient(
    to bottom,
    #ff8b8b,
    #ff8284,
    #ff787d,
    #ff6e76,
    #ff646f,
    #ff5c6a,
    #ff5464,
    #ff4b5f,
    #ff4359,
    #ff3b54,
    #ff314e,
    #ff2648
  );
}
.v-avatar.color-avatar-warning {
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(
    to bottom,
    #ff8b8b,
    #ff8284,
    #ff787d,
    #ff6e76,
    #ff646f,
    #ff5c6a,
    #ff5464,
    #ff4b5f,
    #ff4359,
    #ff3b54,
    #ff314e,
    #ff2648
  );
}
</style>